// Utils
import { component } from 'picoapp';

import { repaint } from 'utils/node';

export default component((node) => {
  const classes = {
    active: 'product__floating-form--active',
  };
  let isActive = false;

  const content = document.querySelector('[data-content]');

  const show = () => {
    isActive = true;

    node.hidden = false;
    repaint(node);

    node.classList.add(classes.active);
  };

  const hide = () => {
    isActive = false;
    node.classList.remove(classes.active);

    node.addEventListener('transitionend', () => {
      if (isActive === false) {
        node.hidden = true;
      }
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        hide();
      } else {
        show();
      }
    });
  });

  observer.observe(content);

  node.querySelector('button').addEventListener('click', () => {
    content.scrollIntoView({ behavior: 'smooth' });
  });
});
